export default "__VITE_ASSET__L1deO_w2__"